import { render, staticRenderFns } from "./ProductGeneralInfoList.vue?vue&type=template&id=ae7eceb2&scoped=true&"
import script from "./ProductGeneralInfoList.vue?vue&type=script&lang=js&"
export * from "./ProductGeneralInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7eceb2",
  null
  
)

export default component.exports